/**
 * Created by fyzu on 25.07.16.
 */

function onScroll(event) {
    var scrollPos = $(document).scrollTop();
    $('.franchise-menu-list .franchise-menu-list-item .franchise-menu-list-item-link').each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
            $('.franchise-menu-list .franchise-menu-list-item .franchise-menu-list-item-link').removeClass("active");
            currLink.addClass("active");
        } else {
            currLink.removeClass("active");
        }
    });
}

var FranchiseService = (function () {

    'use strict';

    function init() {


        // $('.js-show-form-modal').click(function (event) {
        //     event.preventDefault();
        //     $('.js-franchise-form-modal').show();
        // });
        // $(document).mouseup(function (e) {
        //     var container = $(".js-franchise-form-modal");
        //     if (container.has(e.target).length === 0) {
        //         container.hide();
        //     }
        // });

        // $('.js-franchise-form-modal-close').click(function () {
        //     $('.js-franchise-form-modal').hide();
        // });

        $('.js-franchise-success-modal-close').click(function () {
            $('.js-franchise-success-modal').hide();
        });

        $('.js-franchise-form').submit(function () {
            var data = $(this).serialize();
            $.ajax({
                url: '/franchise?' + data,
                type: 'POST',
                contentType: 'application/json',
                success: function () {
                    $('.js-franchise-success-modal').show();
                    $('.js-franchise-form-modal').hide(500);
                }
            });
            return false;
        });

        // $('.js-franchise-menu').click(function (e) {
        //     e.preventDefault();
        //
        //     var el = $(this).attr('href');
        //
        //     $('html, body').animate({
        //         scrollTop: $(el).offset().top - 100
        //     }, 1000);
        //
        //     return false;
        // });

        $(document).on("scroll", onScroll);

        //smoothscroll
        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();
            $(document).off("scroll");

            $('a').each(function () {
                $(this).removeClass('active');
            });
            $(this).addClass('active');

            var target = this.hash,
                menu = target;
            $('html, body').stop().animate({
                'scrollTop': $(target).offset().top + 2
            }, 500, 'swing', function () {
                window.location.hash = target;
                $(document).on("scroll", onScroll);
            });
            var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (width < 769) {
                $('.franchise-menu-list').slideToggle();
            }
        });

//        var menu = $('.franchise-menu-list .franchise-menu-list-item');
//         var menuHeight = $('.franchise-menu-list').height();
//        $('.franchise-menu-list').css('display','block');
//         $('.js-click-franchise-menu').click(function (e) {
//             e.preventDefault();
//             $('.franchise-menu-list').slideToggle();
//         });
    }

    //************ Public ************//
    return {
        init: init,
    };
})();


